import { render, staticRenderFns } from "./AddUnit.vue?vue&type=template&id=2ddaee7c"
import script from "./AddUnit.vue?vue&type=script&lang=js"
export * from "./AddUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports